import React from "react"
import "./index.scss"

export default function ListItem({ text, children, maxWidth }) {
  // Check if maxWidth includes a unit (%, em, rem, etc.)
  // If it doesn't, assume pixels and add px
  const formattedMaxWidth = maxWidth 
    ? maxWidth.toString().match(/[a-z%]+$/i) 
      ? maxWidth 
      : `${maxWidth}px`
    : undefined;

  const textStyle = formattedMaxWidth
    ? {
      maxWidth: formattedMaxWidth,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }
    : {};

  return (
    <div className="list-item">
      <p style={textStyle} title={text}>
        {text}
      </p>
      <div className="list-item-actions">
        {children}
      </div>
    </div>
  );
}
